import React from 'react';
import { Check } from 'lucide-react';
import illustration from '../../assets/illustrations/LandingPage/site de vendas V2-12.png';
import illustrationFace from '../../assets/illustrations/LandingPage/site de vendas V2-13.png';

const BOOKS = ['A Hora da Estrela', 'Um Sopro de Vida', 'Onde Estivestes de Noite'];
const CIRCLE_TEXT = 'EM BREVE · EM BREVE · EM BREVE · EM BREVE · EM BREVE · ';

const EmBreveSection: React.FC = () => (
  <section className="relative w-full bg-champagne py-16 lg:py-24">
    <style>{`
      @keyframes spin-slow {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
      .animate-spin-slow { animation: spin-slow 14s linear infinite; }
    `}</style>

    {/* Ilustração decorativa esquerda */}
    <img
      src={illustrationFace}
      alt=""
      aria-hidden="true"
      className="hidden lg:block w-[240px] absolute left-0 top-[-224px] translate-y-[35%] object-contain pointer-events-none select-none z-20"
    />

    {/* Ilustração decorativa direita */}
    <img
      src={illustration}
      alt=""
      aria-hidden="true"
      className="hidden lg:block w-[240px] absolute right-0 translate-y-[35%] object-contain pointer-events-none select-none z-20"
    />

    <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-8 flex items-center justify-center min-h-[420px]">
      <div className="flex flex-col md:flex-row items-center gap-6 md:gap-0">

        {/* Texto circular girando */}
        <div className="hidden lg:block animate-spin-slow w-[200px] h-[200px] flex-shrink-0 md:-mr-16 md:-mt-64">
          <svg viewBox="0 0 200 200" className="w-full h-full">
            <defs>
              <path
                id="embreve-circle"
                d="M 100,100 m -78,0 a 78,78 0 1,1 156,0 a 78,78 0 1,1 -156,0"
              />
            </defs>
            <text
              fill="#ea3e23"
              fontSize="10"
              fontFamily="Alternate, sans-serif"
              letterSpacing="3.5"
              fontWeight="bold"
            >
              <textPath href="#embreve-circle">{CIRCLE_TEXT}</textPath>
            </text>
          </svg>
        </div>

        {/* Card circular */}
        <div className="relative bg-champagne border-[3px] border-[#1f5c57] rounded-full p-3 shadow-md">
          <div className="relative bg-[#d7cdbd] rounded-full w-[300px] lg:w-[360px] h-[300px] lg:h-[360px] flex flex-col items-center justify-center text-center px-10">

            <p className="font-alternate font-bold text-rose text-[1.75rem] italic leading-none mb-2">
              ESTARÁ DISPONÍVEL EM BREVE!
            </p>
            <div className="w-20 h-px bg-cafe mb-3" />

            <p className="font-alternate font-bold text-cafe text-xs uppercase leading-snug mb-1">
              CLUBE DO LIVRO NO DIVÃ{' '}
              <span className="font-roboto normal-case text-[10px]">com</span>
              <br />
              CLARICE LISPECTOR - ciclo 1 e 2
            </p>

            <p className="font-roboto text-cafe text-[11px] italic leading-snug mb-3">
              ler Clarice de um jeito fácil e focado em<br />reflexões pessoais.
            </p>

            <div className="w-20 h-px bg-cafe mb-4" />

            <a
              href="https://a7560da0.sibforms.com/v2/serve/MUIFAJSksx5e9aco8tsO_w3qUXQqJi4APiC7o3TjwKhZhA71-Vv3-6tU44Tb4L08etYPoB8aFrJVGVHkEEMVtAYxhDXiQonQWJHgKEXc7E3jR3ep5exUF_3fGe4QnlW_2es51LoZ-LSqXglgr19AGB6rb-jBseXbjspmFQPk-PXzDXwIrku07gRMxmW-PpRz9Dx7qnFCRUF21IYa"
              target="_blank"
              rel="noopener noreferrer"
              className="lg:absolute lg:bottom-[40px] lg:right-[-60px] h-[50px] bg-verde-musgo text-champagne font-alternate font-bold text-xs px-7 py-2.5 rounded-full uppercase tracking-widest hover:scale-105 transition-transform duration-300 flex items-center justify-center"
            >
              AVISE-ME !
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default EmBreveSection;
